import {
    USER_ANALYTICS_TRACKER_DELETE,
    USER_ANALYTICS_TRACKER_UPDATE,
    USER_ANALYTICS_SET,
} from './userAnalyticsConstants';
import { MNUserAnalyticsDocument, MNUserAnalyticsTrackerState, UserAnalyticsTrackerType } from './userAnalyticsTypes';

export const updateUserAnalyticsTracker = ({
    trackerType,
    state,
}: {
    trackerType: UserAnalyticsTrackerType;
    state: MNUserAnalyticsTrackerState;
}) => ({
    type: USER_ANALYTICS_TRACKER_UPDATE,
    trackerType,
    state,
    sync: true,
});

export const removeUserAnalyticsTracker = ({ trackerType }: { trackerType: UserAnalyticsTrackerType }) => ({
    type: USER_ANALYTICS_TRACKER_DELETE,
    trackerType,
    sync: true,
});

export const setUserAnalytics = ({ analytics }: { analytics?: MNUserAnalyticsDocument[] }) => ({
    type: USER_ANALYTICS_SET,
    analytics,
});
